import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import CustomToast from '../../components/CustomToast';



function useParticipate(fetchTaskDataO,handleClose, setLoader, taskIds, handleShow1, taskData, id) {
    const [uniqueCode, setUniqueCode] = useState(null);
    const [uniqueStatus, setUniqueStatus] = useState(null);
    const [userId, setUserId] = useState(null);

    // Utility function to retrieve access token and user ID
    const getAuthHeaders = () => {
        const accessToken = localStorage.getItem("accessToken");
      
        return { accessToken, userId };
    };

    const participate = async () => {
        handleClose();
        setLoader(true);
        try {
            const { accessToken } = getAuthHeaders(); // Fetch access token
            const config = {
                headers: {
                    Authorization: `Bearer ${accessToken}`, // Add the token to the Authorization header
                },
            };

            const data = { taskId: taskIds };
            const response = await axios.post(`${API_URL}participants`, data, config);

            setUniqueCode(response?.data?.data?.uniqueCode);
            setUniqueStatus(response?.data?.data?.status);
            setLoader(false);
            fetchTaskDataO()
            handleShow1();
        } catch (error) {
            setLoader(false);
            // toast.error("Something went wrong");
             CustomToast.show('error', 'Error!', 'Something went wrong')

            console.error("Error participating in task:", error);
        }
    };

    const fetchPrticipateData = async () => {
        try {
            const { accessToken } = getAuthHeaders(); // Fetch access token
            const config = accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : {};
            const secretCodeResponse = await axios.get(`${API_URL}participants/unique-code/${id}`, config);

            setUniqueCode(secretCodeResponse?.data?.data?.uniqueCode);
            setUniqueStatus(secretCodeResponse?.data?.data?.status);
        } catch (error) {
            console.error("Error fetching task data:", error);
        }
    };

    useEffect(() => {
        if (taskData?.hasParticipated && id) {
            fetchPrticipateData(); // Fetch data only when taskData exists and id is valid
        }
        const userId = localStorage.getItem("userId");
        setUserId(userId);  // Only update when necessary
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, [id, taskData?.hasParticipated]); // Refined dependencies

    return { uniqueCode, uniqueStatus, userId, participate, fetchPrticipateData };
}

export default useParticipate;
